import Vue from 'vue'
import Frame from './pages/Frame.vue'
import router from './router'
import localisation from './localisation/localisation'
import { user } from './fire'
import MDE from 'vue-simplemde'


// The firebase client needs to be created up front by calling it in some way
const _ = user


// Mounting point
Vue.mixin(localisation.mixin)
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.component('MDE', MDE)
new Vue({
	router,
	i18n: localisation.i18n,
	render: h => h(Frame)
}).$mount('#app')